export const COMPONENT_NAME = "shared-input-currency";
